/* eslint-disable */

declare global {
  interface Window {
    gtag: (type: string, action: string, details: unknown) => void
  }
}

export const event = (action: string, details?: unknown): void => {
  window.gtag && window.gtag('event', action, details)
}
